
import courses from "./courses";


const years = [
  2026,2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013,
  2012, 2011, 2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,
];

const ugInput = [

    { breakTitle: "Enter High School Details", type: "break", required: false },
    {
      name: "high_school_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },
    {
      name: "high_school_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "high_school_board",
      type: "text",
      label: "Board",
      required: false,
    },
     
    {
      name: "high_school_name",
      type: "text",
      label: "School/College Name",
      required: false,
    },

    {
      name: "high_school_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
   
    {
      name: "high_school_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
    
    {
      name: "high_school_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },
    
    {
      breakTitle: "Enter Intermediate Details",
      type: "break",
      required: false,
    },
    {
      name: "intermediate_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },
    {
      name: "intermediate_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "intermediate_board",
      type: "text",
      label: "Board",
      required: false,
    },
    
    {
      name: "intermediate_name",
      type: "text",
      label: "School/College Name",
      required: false,
    },

     {
      name: "intermediate_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
    
    {
      name: "intermediate_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
   
    {
      name: "intermediate_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },
   
   


    { breakTitle: "Others", type: "break", required: false },

     {
      name: "other_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },
    {
      name: "other_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "other_board",
      type: "text",
      label: "Board",
      required: false,
    },
    
    {
      name: "other_name",
      type: "text",
      label: "School/College Name",
      required: false,
    },

     {
      name: "other_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
    
    {
      name: "other_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
   
    {
      name: "other_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },
   
   

    
     { breakTitle: "क्या आपकी पढ़ाई में कोई गैप है?", type: "break", required: false },

     


     {
      name: "gap",
      type: "radio",

      label:"यदि हाँ, तो गैप प्रमाण पत्र (शपथ पत्र) जमा करें।",
      
      values: ["Yes", "No"],
      required: false,
    },




  ]

  const pgInput = [



    { breakTitle: "Enter High School Details", type: "break", required: false },


    {
      name: "high_school_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },
    {
      name: "high_school_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "high_school_board",
      type: "text",
      label: "Board",
      required: false,
    },
     
    {
      name: "high_school_name",
      type: "text",
      label: "School/College Name",
      required: false,
    },

    {
      name: "high_school_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
   
    {
      name: "high_school_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
    
    {
      name: "high_school_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },
    
    {
      breakTitle: "Enter Intermediate Details",
      type: "break",
      required: false,
    },
    {
      name: "intermediate_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },
    {
      name: "intermediate_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "intermediate_board",
      type: "text",
      label: "Board",
      required: false,
    },
    
    {
      name: "intermediate_name",
      type: "text",
      label: "School/College Name",
      required: false,
    },

     {
      name: "intermediate_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
    
    {
      name: "intermediate_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
   
    {
      name: "intermediate_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },
   
    { breakTitle: "Enter UG Details", type: "break", required: false },
    {
      name: "ug_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },

     {
      name: "ug_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "ug_board",
      type: "text",
      label: "University",
      required: false,
    },
    {
      name: "ug_name",
      type: "text",
      label: "College Name",
      required: false,
    },
       {
      name: "ug_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
   
    {
      name: "ug_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
 
    {
      name: "ug_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },


    { breakTitle: "Others", type: "break", required: false },

    {
      name: "other_year",
      type: "select",
      values: years,
      label: "Passing Year",
      required: false,
    },

     {
      name: "other_roll",
      type: "text",
      label: "Roll No.",
      required: false,
    },
    {
      name: "other_board",
      type: "text",
      label: "Board",
      required: false,
    },
    {
      name: "other_name",
      type: "text",
      label: "School/College Name",
      required: false,
    },
       {
      name: "other_obtmarks",
      type: "number",
      label: "Obtained Marks",
      required: false,
    },
   
    {
      name: "other_maxmarks",
      type: "number",
      label: "Total Marks",
      required: false,
    },
 
    {
      name: "other_percentage",
      type: "number",
      label: "Percentage",
      required: false,
    },

     { breakTitle: "क्या आपकी पढ़ाई में कोई गैप है ?", type: "break", required: false },

     {
      name: "gap",
      type: "radio",

      label:"यदि हाँ, तो गैप प्रमाण पत्र (शपथ पत्र) जमा करें।",
      
      values: ["Yes", "No"],
      required: false,
    },

    







    
  ];





const edu_attachment =   courses.filter((e)=>e.code==window.location.toString().split("/")[5]?.toUpperCase())[0]?.type=== "UG" ? ugInput :  pgInput 

const subjects =
  window.location.toString().split("/")[4] === "bsc"
    ? ["Physics", "Chemistry", "Maths", "Botany", "Zoology"]
    : window.location.toString().split("/")[4] === "ba"
    ? [
        "हिंदी",
        "अंग्रेज़ी",
        "संस्कृत",
        "शारीरिक शिक्षा",
        "समाज शास्त्र",
        "राजनीतिक शास्त्र",
        "इतिहास",
        "भूगोल",
      ]
    : [
        "Business Communication",
        "Business Statistics",
        "Business Organisation",
        "Introduction to Computer Application",
      ];


      
const Form1 = {
  "Basic Info": [

    { breakTitle: "Student Details", type: "break", required: false },


     {
      name: "part",
      type: "text",
      label: "Course Year",
      required: false,
    },
   
    {
      name: "applicant_name",
      type: "text",
      label: "Applicant Name",
      required: false,
    },
    { name: "dob", type: "date", label: "Date of Birth", required: false },
    {
      name: "gender",
      type: "select",
      label: "Gender",
      values: ["male", "female", "other"],
      required: false,
    },
    {
      name: "nationality",
      type: "select",
      label: "Nationality",
      values: ["Resident of India", "Non resident of India"],
      required: false,
    },
    {
      name: "aadhar_no",
      type: "text",
      label: "Aadhar Number",
      required: false,
    },
    {
      name: "whatsapp_number",
      type: "tel",
      label: "Whatsapp Number",
      required: false,
    },
    { name: "email", type: "email", label: "Email", required: false },
    { name: "urn", type: "text", label: "Unique ID No.", required: false },
    {
      name: "category",
      type: "select",
      label: "Caste Category",
      values: ["GENERAL", "OBC", "SC", "ST"],
      required: false,
    },

    {
      name: "sub_category",
      type: "text",
      label: "Caste Name",
      required: false,
    },
    {
      name: "caste_certificate_number",
      type: "text",
      label: "Caste Certificate Number",
      required: false,
    },

    {
      name: "father_name",
      type: "text",
      label: "Father's Name",
      required: false,
    },
    {
      name: "father_occupation",
      type: "text",
      label: "Father's Occupation",
      required: false,
    },
    {
      name: "mother_name",
      type: "text",
      label: "Mother's Name",
      required: false,
    },
    {
      name: "mother_occupation",
      type: "text",
      label: "Mother's Occupation",
      required: false,
    },

     {
      name: "marital_status",
      type: "select",
      label: "Marital Status",
      values: ["Married", "Single","Divorced","Widowed","Separated"],
      required: false,
    },
     { breakTitle: "Permanent Address", type: "break", required: false },
    {
      name: "permanent_address_village_mohalla",
      type: "text",
      label: "Village/Mohalla",
      required: false,
    },
     {
      name: "permanent_address_post",
      type: "text",
      label: "Post",
      required: false,
    },
     {
      name: "permanent_address_tehsil",
      type: "text",
      label: "Tehsil",
      required: false,
    },
     {
      name: "permanent_address_district",
      type: "text",
      label: "District",
      required: false,
    },
     {
      name: "permanent_address_pincode",
      type: "text",
      label: "Pin Code",
      required: false,
    },
   
  ],

  eligibility: [
    {
      name: "horizontal_reservation",
      type: "checkbox",
      label: "Horizontal Reservation",
      values: [
        "Disable Person(दिव्यांग)",
        "Freedom Fighter(स्वतंत्रता सेनानी पाल्य)",
        "Defense Person(प्रतिरक्षा कर्मचारी)",
      ],
      required: false,
    },

    {
      name: "weightage",
      type: "checkbox",
      label: "Other Achievments",
      values: ["N.C.C", "N.S.S", "Sports", "Scout"],
      required: false,
    },

  ],

  education_details: edu_attachment,

  upload_section: [

    { breakTitle: "Documents to be submit with application form ", type: "break", required: false },

    {
      name: "attachments",
      type: "checkbox",
    
      values: [
        "10th Marksheet",
        "12th Marksheet",
        "UG Marksheet",
        "Other Course",
        "Aadhar Card",
        "Caste Certificate",
        "Domicile Certificate",
        "TC & CC Original Copy",
        "Income Certificate",
        "Anti Ragging Affidavit",
        
      ],
      required: false,
    },

    {
      name: "agreed_to_declaration",
      type: "checkbox",
      label:
        "मैंने महाविद्यालय विवरण पुस्तिका में घोषणा करता। करती हूँ कि उपरोक्त समस्त विवरण मेरी जानकारी के अनुसार सत्य है। तथ्य असत्य पाये जाने पर अथवा जानबूझ कर द्विपाये जाने पर मेरा प्रवेश निरस्त कर दिये जाने पर मुझे कोई आपत्ति नहीं होगी। मैंने रैगिंग अधिनियम 2009 का पढ़ लिया है, और उसका अक्षरशः पालन करूंगा। करूंगी।",
    },

    
  ],
};

export default Form1;
